import { useLoader } from "../../../components/loader";
import { GUJARAT_GST_CODE } from "../../../constant/commonConst";
import { fetcher } from "../../../helper/api";
import logoYellow from "../../../assets/images/mail_logo.jpg";
import { generateRows } from "./headerColumns";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import "../../../assets/fonts/Bahnschrift-normal";
import "../../../assets/fonts/Bahnschrift-bold";
import { downloadPDF } from "../../../constant/icons";
import { Button, UncontrolledTooltip } from "reactstrap";
import { useState } from "react";
import moment from "moment";
import "../../../assets/fonts/style.css";
import { PDF_CONSTANTS } from "./pdfConstants";

export default function GeneratePdf(props: any) {
  const { column, rowData } = props;
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggleTooltip = () => {
    setTooltipOpen(!tooltipOpen);
  };
  const loading = useLoader();

  const doc: any = new jsPDF();
  const constants = PDF_CONSTANTS(doc);
  const normalizeColumnName = (col: any) =>
    col.replace(/\s+/g, "").toLowerCase();
  let y = 0;
  let isLastPage = false;

  // Updated function to draw footer border on any page - now accepts contentEndY to avoid overlap
  // const drawFooterBorder = (contentEndY?: number) => {
  //   const { pageWidth, pageHeight, margins, colors } = constants;
  //   const minBorderSpacing = 10; // Minimum space between content and border
  //   const defaultBorderY = pageHeight - 15; // Default 15px from bottom

  //   // Calculate the actual border position
  //   let borderY = defaultBorderY;
  //   if (contentEndY) {
  //     // Ensure border is at least minBorderSpacing below the content
  //     const minBorderY = contentEndY + minBorderSpacing;
  //     borderY = Math.max(minBorderY, defaultBorderY);
  //   }

  //   doc.setDrawColor(...colors.yellow); // Yellow color
  //   doc.setLineWidth(5); // 5px width
  //   doc.line(margins.left, borderY, pageWidth - margins.right, borderY);
  // };

  const addHeader = (proposalData: any): number => {
    const { pageWidth, margins, colors, fonts, layout } = constants;
    const { left: leftMargin, right: rightMargin } = margins;
    const { logo, title, proposalSheet, sections } = layout;
    const maxWidth = pageWidth - sections.rightX - rightMargin;

    // Fixed top content (logo and right-aligned titles)
    doc.addImage(logoYellow, "PNG", logo.x, logo.y, logo.width, logo.height);
    doc.setFontSize(fonts.sizes.subtitle);
    try {
      doc.setFont(fonts.primary, "bold");
    } catch (e) {
      doc.setFont(fonts.fallback, "bold");
    }
    doc.text(
      "ADVERTISING SERVICES",
      pageWidth - rightMargin,
      title.advertisingServicesY,
      { align: "right" }
    );
    doc.setFontSize(fonts.sizes.small);
    doc.setFont(fonts.primary, "normal");
    doc.text("PROPOSAL SHEET", pageWidth - rightMargin, title.proposalSheetY, {
      align: "right",
    });

    // Proposal Sheet details
    doc.setFontSize(fonts.sizes.title);
    doc.setTextColor(...colors.yellow);
    doc.text("PROPOSAL SHEET", proposalSheet.x, proposalSheet.titleY);
    doc.setFontSize(fonts.sizes.normal);
    doc.setTextColor(...colors.gray);
    doc.text(
      `Proposal ID: ${proposalData.prososalNo || ""}`,
      proposalSheet.x,
      proposalSheet.details.proposalIdY
    );
    doc.text(
      `Proposal Date: ${moment(proposalData.createDate).format("DD/MM/YYYY")}`,
      proposalSheet.x,
      proposalSheet.details.proposalDateY
    );
    doc.text(
      `Proposal By: ${proposalData.contactPerson || ""}`,
      proposalSheet.x,
      proposalSheet.details.proposalByY
    );

    // Left section: Proposal From
    doc.setFontSize(fonts.sizes.title);
    doc.setTextColor(...colors.yellow);
    doc.text("Proposal From", sections.leftX, sections.startY);

    doc.setFont(fonts.fallback, "bold");
    doc.setFontSize(fonts.sizes.normal);
    doc.setTextColor(...colors.black);
    doc.text(
      "CRAFT MEDIA",
      sections.leftX,
      sections.startY + sections.nameOffsetY
    );

    doc.setFont(fonts.primary, "normal");
    doc.setTextColor(...colors.gray);
    doc.setFontSize(fonts.sizes.small);
    const leftAddressStartY = sections.startY + sections.addressStartOffsetY;
    const leftAddressLines = [
      "A-409, The Landmark, URJANAGAR-I",
      "Kudasan, 382421, Gandhinagar - GUJ (IND)",
      "GSTIN / UNI: 24BVWPM5351E1ZB",
      "STATE NAME: GUJARAT",
      "PAN: 24BVWPM5351E",
      "CONTACT NO: +91 9586622346, +91 9586522346",
    ];
    leftAddressLines.forEach((line, idx) => {
      doc.text(
        line,
        sections.leftX,
        leftAddressStartY + idx * sections.leftAddressLineHeight
      );
    });
    const leftSectionLastY =
      leftAddressStartY +
      (leftAddressLines.length - 1) * sections.leftAddressLineHeight;

    // Right section: Proposal For
    doc.setFontSize(fonts.sizes.title);
    doc.setTextColor(...colors.yellow);
    doc.text("Proposal For", sections.rightX, sections.startY);

    doc.setFont(fonts.fallback, "bold");
    doc.setFontSize(fonts.sizes.normal);
    doc.setTextColor(...colors.black);
    doc.text(
      `${proposalData.client?.contactPerson || ""}`,
      sections.rightX,
      sections.startY + sections.nameOffsetY
    );

    doc.setFont(fonts.primary, "normal");
    doc.setTextColor(...colors.gray);
    doc.setFontSize(fonts.sizes.small);
    const rightAddressStartY = sections.startY + sections.addressStartOffsetY;
    const address = `ADDRESS: ${proposalData.client?.billingAddress || ""}`;
    const wrappedAddress = doc.splitTextToSize(address, maxWidth);

    let addressY = rightAddressStartY;
    wrappedAddress.forEach((line: string) => {
      doc.text(line, sections.rightX, addressY);
      addressY += sections.rightAddressLineHeight;
    });
    const fieldsStartY = addressY;

    const fields = [
      `GSTIN / INI: ${proposalData.client?.GSTIN || ""}`,
      "PLACE OF SUPPLY:",
      "STATE NAME:",
      "STATE CODE:",
      `PAN: ${proposalData.client?.PANNo || ""}`,
      `CONTACT NO: ${proposalData.client?.contactPersonMobileNo || ""}`,
    ];
    let fieldY = fieldsStartY;
    fields.forEach((field: string) => {
      doc.text(field, sections.rightX, fieldY);
      fieldY += sections.fieldLineHeight;
    });
    const rightSectionLastY =
      fieldsStartY + (fields.length - 1) * sections.fieldLineHeight;

    return Math.max(leftSectionLastY, rightSectionLastY);
  };

  const addTableHeader = (tableStartY: number) => {
    const { colors, fonts, layout, margins, pageWidth } = constants;
    const { table } = layout;
    const tableWidth = pageWidth - margins.left - margins.right;
    doc.setFontSize(fonts.sizes.subtitle);
    doc.setFont(fonts.fallback, "bold");
    doc.setTextColor(...colors.black);
    doc.text("SUMMARY OF SERVICES CHARGES", table.summaryX, tableStartY - 4);
    const amountX = margins.left + tableWidth - doc.getTextWidth("AMOUNT") - 7;
    doc.text("AMOUNT", amountX, tableStartY - 4);
    y = tableStartY + 0; // Increase y after header to provide space for section titles
  };

  // Updated addFooter function - tracks final Y position and passes it to drawFooterBorder
  // const addFooter = (proposalData: any, currentY: number) => {
  //   const { pageWidth, pageHeight, margins, colors, fonts, layout } = constants;
  //   const { terms, contact, totals } = layout.footer;
  //   const SubTotalAmount = proposalData.mediaInventory.reduce(
  //     (acc: any, item: any) => acc + (item.amount || 0),
  //     0
  //   );
  //   const igstAmount = SubTotalAmount * 0.18;
  //   const cgstAmount = SubTotalAmount * 0.09;
  //   const sgstAmount = SubTotalAmount * 0.09;
  //   const isGujaratGstNo = proposalData?.client?.GSTIN
  //     ? proposalData?.client?.GSTIN.substring(-2) === GUJARAT_GST_CODE
  //     : false;

  //   // Start footer immediately after table content with small spacing
  //   const footerSpacing = 10; // Small gap between table and footer
  //   let footerContentY = currentY + footerSpacing;
  //   let maxFooterY = footerContentY; // Track the maximum Y position used

  //   doc.setFontSize(fonts.sizes.normal);
  //   doc.setFont(fonts.fallback, "bold");
  //   doc.setTextColor(...colors.black);
  //   doc.text("TERMS & CONDITIONS", margins.left + 0, footerContentY);
  //   footerContentY += terms.titleOffsetY;

  //   // Add extra spacing before termsList
  //   const termsSpacing = 2; // Adjust this value to increase/decrease space
  //   footerContentY += termsSpacing;

  //   doc.setFont(fonts.primary, "normal");
  //   doc.setFontSize(fonts.sizes.tiny);
  //   // Extract term description from booking data
  //   const termDescription = proposalData?.term?.description || "";

  //   // Convert multi-line description into array of lines
  //   const termsList = termDescription
  //     .split("\n")
  //     .map((line: any) => line.trim())
  //     .filter((line: any) => line.length > 0);

  //   // const termsList = [
  //   //   "ALL MEDIA SITES WILL BE BLOCKED FOR ONLY 4 WORKING DAYS.",
  //   //   "ALL MEDIA SITES ARE SUBJECT TO AVAILABILITY AT THE TIME OF FINAL CONFIRMATION.",
  //   //   "MAIL CONFIRMATION OR PURCHASE ORDER IS MANDATORY TO START THE CAMPAIGN.",
  //   //   "FLEX BANNER PRINTING CHARGES WILL BE EXTRA AS PER MEDIA QUALITY - REGULAR/BLACK BACK/BLACKLIT MEDIA.",
  //   //   "FLEX BANNER MOUNTING CHARGES WILL BE EXTRA - RS. 3 PER SQFT.",
  //   //   "APPLICABLE TAX GST 18% WILL BE EXTRA AS PER GOVERNMENT RULES AND REGULATIONS.",
  //   //   "CAMPAIGN EXECUTION WILL TAKE 2 DAYS FOR CITY AND 5 TO 7 DAYS FOR UPCOUNTRY.",
  //   //   "AVAILABLE DATES MAY CHANGE IN CASE OF PRESENT CAMPAIGN RENEWAL.",
  //   //   "INVOICING WILL START WITHIN 5 DAYS OF CONFIRMATION,",
  //   //   "IT IS REQUESTED TO DELIVER YOUR ARTWORK-FLEX BANNERS BEFORES 3 DAYS BEFORE CAMPAIGN UP.",
  //   //   "FOR ANY REASONS, IF YOUR FLEX IS DAMAGE IT WILL BE YOUR RESPONSIBILITY TO PROVIDE NEW FLEX BANNER TO US",
  //   //   "OR GIVE APPROVAL TO BE PRINT FLEX BANNER.",
  //   // ];

  //   const maxWidth = pageWidth * 0.5 - margins.left; // 50% of page width minus left margin
  //   // termsList.forEach((term: any) => {
  //   //   const wrappedText = doc.splitTextToSize(term, maxWidth);
  //   //   wrappedText.forEach((line: string) => {
  //   //     doc.text(line, margins.left, footerContentY);
  //   //     footerContentY += terms.lineHeight;
  //   //   });
  //   // });
  //   termsList.forEach((term: string) => {
  //     const wrappedText = doc.splitTextToSize(term, maxWidth);
  //     wrappedText.forEach((line: string) => {
  //       if (footerContentY > pageHeight - margins.bottom - 10) {
  //         doc.addPage();
  //         footerContentY = margins.top;
  //       }
  //       doc.text(line, margins.left, footerContentY);
  //       footerContentY += terms.lineHeight;
  //     });
  //   });

  //   footerContentY += terms.spacingBeforeContact;

  //   doc.setFontSize(fonts.sizes.normal);
  //   doc.setFont(fonts.fallback, "bold");
  //   doc.setTextColor(...colors.black);
  //   doc.text("Contact Us", margins.left + 0, footerContentY);
  //   footerContentY += contact.lineHeight;

  //   doc.setFont(fonts.primary, "normal");
  //   doc.setFontSize(fonts.sizes.small);
  //   doc.setTextColor(...colors.black);
  //   doc.text(
  //     "Call - 95866 22346, 9586522346",
  //     margins.left + 0,
  //     footerContentY
  //   );
  //   footerContentY += contact.lineHeight;
  //   doc.text(
  //     "E mail - info.craftmedia@gmail.com",
  //     margins.left + 0,
  //     footerContentY
  //   );
  //   footerContentY += contact.lineHeight;
  //   doc.text("Web - www.craftmedia.in", margins.left + 0, footerContentY);
  //   footerContentY += contact.lineHeight; // Add spacing after last contact line

  //   // Update maxFooterY to track the end of left column content
  //   maxFooterY = Math.max(maxFooterY, footerContentY);

  //   // Position totals section on the right, starting from the same Y as terms
  //   let totalsStartY = currentY + footerSpacing;
  //   let gstOffset = 0;
  //   doc.setFontSize(fonts.sizes.normal);
  //   doc.setFont(fonts.fallback, "bold");
  //   doc.setTextColor(...colors.black);
  //   doc.text(
  //     `SUB TOTAL IN INR: ${SubTotalAmount?.toFixed(2)}`,
  //     layout.sections.rightX,
  //     totalsStartY + gstOffset
  //   );
  //   gstOffset += totals.lineHeight;
  //   if (isGujaratGstNo) {
  //     doc.text(
  //       `IGST @ 18%: ${igstAmount?.toFixed(2)}`,
  //       layout.sections.rightX,
  //       totalsStartY + gstOffset
  //     );
  //     gstOffset += totals.lineHeight;
  //   }
  //   doc.text(
  //     `CGST @ 9%: ${cgstAmount?.toFixed(2)}`,
  //     layout.sections.rightX,
  //     totalsStartY + gstOffset
  //   );
  //   gstOffset += totals.lineHeight;
  //   doc.text(
  //     `SGST @ 9%: ${sgstAmount?.toFixed(2)}`,
  //     layout.sections.rightX,
  //     totalsStartY + gstOffset
  //   );
  //   gstOffset += totals.spaceBeforeTotal;

  //   doc.setFontSize(fonts.sizes.large);
  //   doc.setFont(fonts.primary, "normal");
  //   doc.setTextColor(...colors.gray);
  //   const totalTextX = layout.sections.rightX;
  //   const totalTextY = totalsStartY + gstOffset;

  //   doc.text(
  //     `Total (INR): ${isGujaratGstNo
  //       ? (SubTotalAmount + igstAmount)?.toFixed(2)
  //       : (SubTotalAmount + cgstAmount + sgstAmount)?.toFixed(2)
  //     }`,
  //     totalTextX,
  //     totalTextY
  //   );

  //   doc.setDrawColor(...colors.black);
  //   doc.setLineWidth(layout.footer.lineWidth);
  //   doc.line(
  //     totalTextX,
  //     totalTextY - totals.totalLineOffset,
  //     totalTextX + totals.totalLineWidth,
  //     totalTextY - totals.totalLineOffset
  //   );
  //   doc.line(
  //     totalTextX,
  //     totalTextY + 3,
  //     totalTextX + totals.totalLineWidth,
  //     totalTextY + 3
  //   );

  //   doc.setFont(fonts.primary, "normal");
  //   doc.setFontSize(fonts.sizes.small);
  //   doc.setTextColor(...colors.black);
  //   let officeY = totalTextY + totals.officeStartOffsetY;
  //   doc.text(
  //     "Reg Office. 86, Shakti Complex, Opp Krishna Hospital,",
  //     layout.sections.rightX,
  //     officeY
  //   );
  //   officeY += totals.officeLineHeight;
  //   doc.text(
  //     "Mota Chiloda, NH-8, 382 355 Gandhinagar - Guj (IND)",
  //     layout.sections.rightX,
  //     officeY
  //   );
  //   officeY += totals.officeLineHeight * 0.5;

  //   // Add yellow border between Reg Office and Corp Office
  //   const borderSpacing = 2; // Space before and after the border
  //   doc.setDrawColor(255, 193, 7); // Yellow color
  //   doc.setLineWidth(0.5); // 2px height
  //   doc.line(
  //     layout.sections.rightX,
  //     officeY,
  //     layout.sections.rightX + 20, // 30px width
  //     officeY
  //   );
  //   officeY += borderSpacing;
  //   officeY += borderSpacing;

  //   doc.setTextColor(...colors.black); // Reset text color
  //   doc.text(
  //     "Corp Office, A-409, The Landmark, Urjanagar 1",
  //     layout.sections.rightX,
  //     officeY
  //   );
  //   officeY += totals.officeLineHeight;
  //   doc.text(
  //     "Kudasan, 382 421 Gandhinagar - Guj (IND)",
  //     layout.sections.rightX,
  //     officeY
  //   );

  //   // Update maxFooterY to include the right column content
  //   maxFooterY = Math.max(maxFooterY, officeY);

  //   // Draw the footer border with proper spacing from content
  //   // drawFooterBorder(maxFooterY);
  // };
  // const addFooter = (proposalData: any, currentY: number) => {
  //   const { pageWidth, pageHeight, margins, colors, fonts, layout } = constants;
  //   const { terms, contact, totals } = layout.footer;

  //   const SubTotalAmount = proposalData.mediaInventory.reduce(
  //     (acc: any, item: any) => acc + (item.amount || 0),
  //     0
  //   );
  //   const igstAmount = SubTotalAmount * 0.18;
  //   const cgstAmount = SubTotalAmount * 0.09;
  //   const sgstAmount = SubTotalAmount * 0.09;

  //   const isGujaratGstNo = proposalData?.client?.GSTIN
  //     ? proposalData.client.GSTIN.slice(-2) === GUJARAT_GST_CODE
  //     : false;

  //   const footerSpacing = 10;
  //   let footerYLeft = currentY + footerSpacing;
  //   let footerYRight = currentY + footerSpacing;

  //   const checkPageBreak = () => {
  //     if (footerYLeft > pageHeight - margins.bottom - 10 ||
  //       footerYRight > pageHeight - margins.bottom - 10) {
  //       doc.addPage();
  //       footerYLeft = margins.top;
  //       footerYRight = margins.top;
  //     }
  //   };

  //   //================ LEFT COLUMN - TERMS =================//
  //   doc.setFontSize(fonts.sizes.normal);
  //   doc.setFont(fonts.fallback, "bold");
  //   doc.setTextColor(...colors.black);
  //   doc.text("TERMS & CONDITIONS", margins.left, footerYLeft);

  //   footerYLeft += terms.titleOffsetY + 2;

  //   doc.setFont(fonts.primary, "normal");
  //   doc.setFontSize(fonts.sizes.tiny);

  //   const termDesc = proposalData?.term?.description || "";
  //   const termsList = termDesc.split("\n").map((t: any) => t.trim()).filter((t: any) => t);

  //   const maxWidth = pageWidth * 0.5 - margins.left;

  //   termsList.forEach((term: string) => {
  //     const lines = doc.splitTextToSize(term, maxWidth);
  //     lines.forEach((line: string) => {
  //       checkPageBreak();
  //       doc.text(line, margins.left, footerYLeft);
  //       footerYLeft += terms.lineHeight;
  //     });
  //   });

  //   footerYLeft += terms.spacingBeforeContact;

  //   doc.setFontSize(fonts.sizes.normal);
  //   doc.setFont(fonts.fallback, "bold");
  //   doc.text("Contact Us", margins.left, footerYLeft);
  //   footerYLeft += contact.lineHeight;

  //   doc.setFont(fonts.primary, "normal");
  //   doc.setFontSize(fonts.sizes.small);

  //   [
  //     "Call - 95866 22346, 9586522346",
  //     "E mail - info.craftmedia@gmail.com",
  //     "Web - www.craftmedia.in"
  //   ].forEach(line => {
  //     checkPageBreak();
  //     doc.text(line, margins.left, footerYLeft);
  //     footerYLeft += contact.lineHeight;
  //   });


  //   //================ RIGHT COLUMN - TOTALS =================//
  //   const rightX = layout.sections.rightX;
  //   doc.setFontSize(fonts.sizes.normal);
  //   doc.setFont(fonts.fallback, "bold");

  //   const printRightLine = (text: string) => {
  //     checkPageBreak();
  //     doc.text(text, rightX, footerYRight);
  //     footerYRight += totals.lineHeight;
  //   };

  //   printRightLine(`SUB TOTAL IN INR: ${SubTotalAmount.toFixed(2)}`);

  //   if (isGujaratGstNo) printRightLine(`IGST @ 18%: ${igstAmount.toFixed(2)}`);

  //   printRightLine(`CGST @ 9%: ${cgstAmount.toFixed(2)}`);
  //   printRightLine(`SGST @ 9%: ${sgstAmount.toFixed(2)}`);

  //   footerYRight += totals.spaceBeforeTotal;

  //   // Total in Big Font
  //   doc.setFontSize(fonts.sizes.large);
  //   doc.setFont(fonts.primary, "normal");
  //   doc.setTextColor(...colors.gray);
  //   checkPageBreak();
  //   doc.text(
  //     `Total (INR): ${isGujaratGstNo
  //       ? (SubTotalAmount + igstAmount).toFixed(2)
  //       : (SubTotalAmount + cgstAmount + sgstAmount).toFixed(2)
  //     }`,
  //     rightX,
  //     footerYRight
  //   );

  //   doc.setDrawColor(...colors.black);
  //   doc.setLineWidth(layout.footer.lineWidth);
  //   doc.line(
  //     rightX,
  //     footerYRight - totals.totalLineOffset,
  //     rightX + totals.totalLineWidth,
  //     footerYRight - totals.totalLineOffset
  //   );
  //   doc.line(
  //     rightX,
  //     footerYRight + 3,
  //     rightX + totals.totalLineWidth,
  //     footerYRight + 3
  //   );

  //   footerYRight += totals.officeStartOffsetY;

  //   doc.setFontSize(fonts.sizes.small);
  //   doc.setFont(fonts.primary, "normal");
  //   doc.setTextColor(...colors.black);

  //   const rightTextLines = [
  //     "Reg Office. 86, Shakti Complex, Opp Krishna Hospital,",
  //     "Mota Chiloda, NH-8, 382 355 Gandhinagar - Guj (IND)"
  //   ];

  //   rightTextLines.forEach(line => {
  //     checkPageBreak();
  //     doc.text(line, rightX, footerYRight);
  //     footerYRight += totals.officeLineHeight;
  //   });

  //   // Yellow divider
  //   checkPageBreak();
  //   doc.setDrawColor(255, 193, 7);
  //   doc.setLineWidth(0.5);
  //   doc.line(rightX, footerYRight, rightX + 20, footerYRight);
  //   footerYRight += 4;

  //   const corpLines = [
  //     "Corp Office, A-409, The Landmark, Urjanagar 1",
  //     "Kudasan, 382 421 Gandhinagar - Guj (IND)"
  //   ];
  //   corpLines.forEach(line => {
  //     checkPageBreak();
  //     doc.setTextColor(...colors.black);
  //     doc.text(line, rightX, footerYRight);
  //     footerYRight += totals.officeLineHeight;
  //   });
  // };
  // const addFooter = (proposalData: any, currentY: number) => {
  //   const { pageWidth, pageHeight, margins, colors, fonts, layout } = constants;
  //   const { terms, contact, totals } = layout.footer;

  //   const SubTotalAmount = proposalData.mediaInventory.reduce(
  //     (acc: any, item: any) => acc + (item.amount || 0),
  //     0
  //   );

  //   const igstAmount = SubTotalAmount * 0.18;
  //   const cgstAmount = SubTotalAmount * 0.09;
  //   const sgstAmount = SubTotalAmount * 0.09;

  //   const isGujaratGstNo = proposalData?.client?.GSTIN
  //     ? proposalData.client.GSTIN.slice(-2) === GUJARAT_GST_CODE
  //     : false;

  //   const footerSpacing = 10;

  //   // Left starts at original currentY
  //   let footerYLeft = currentY + footerSpacing;

  //   const checkPageBreak = () => {
  //     if (footerYLeft > pageHeight - margins.bottom - 10) {
  //       doc.addPage();
  //       footerYLeft = margins.top;
  //     }
  //   };

  //   //================ LEFT COLUMN - TERMS =================//
  //   doc.setFontSize(fonts.sizes.normal);
  //   doc.setFont(fonts.fallback, "bold");
  //   doc.setTextColor(...colors.black);
  //   doc.text("TERMS & CONDITIONS", margins.left, footerYLeft);

  //   footerYLeft += terms.titleOffsetY + 2;

  //   doc.setFont(fonts.primary, "normal");
  //   doc.setFontSize(fonts.sizes.tiny);

  //   const termDesc = proposalData?.term?.description || "";
  //   const termsList = termDesc.split("\n").map((t: any) => t.trim()).filter((t: any) => t);

  //   const maxWidth = pageWidth * 0.5 - margins.left;

  //   termsList.forEach((term: string) => {
  //     const lines = doc.splitTextToSize(term, maxWidth);
  //     lines.forEach((line: string) => {
  //       checkPageBreak();
  //       doc.text(line, margins.left, footerYLeft);
  //       footerYLeft += terms.lineHeight;
  //     });
  //   });

  //   footerYLeft += terms.spacingBeforeContact;

  //   doc.setFontSize(fonts.sizes.normal);
  //   doc.setFont(fonts.fallback, "bold");
  //   doc.text("Contact Us", margins.left, footerYLeft);
  //   footerYLeft += contact.lineHeight;

  //   doc.setFont(fonts.primary, "normal");
  //   doc.setFontSize(fonts.sizes.small);

  //   [
  //     "Call - 95866 22346, 9586522346",
  //     "E mail - info.craftmedia@gmail.com",
  //     "Web - www.craftmedia.in"
  //   ].forEach(line => {
  //     checkPageBreak();
  //     doc.text(line, margins.left, footerYLeft);
  //     footerYLeft += contact.lineHeight;
  //   });

  //   //================ RIGHT COLUMN - TOTALS =================//

  //   // Align top of totals with Terms & Conditions title
  //   let footerYRight = margins.top + terms.titleOffsetY + footerSpacing;
  //   const rightX = layout.sections.rightX;

  //   // Estimate right content height for page overflow check
  //   const estimatedRightHeight =
  //     totals.lineHeight * 4 +
  //     totals.spaceBeforeTotal +
  //     fonts.sizes.large + 10 +
  //     totals.officeLineHeight * 4;

  //   if (footerYRight + estimatedRightHeight > pageHeight - margins.bottom - 10) {
  //     doc.addPage();
  //     footerYRight = margins.top;
  //   }

  //   doc.setFontSize(fonts.sizes.normal);
  //   doc.setFont(fonts.fallback, "bold");

  //   const printRightLine = (text: string) => {
  //     doc.text(text, rightX, footerYRight);
  //     footerYRight += totals.lineHeight;
  //   };

  //   printRightLine(`SUB TOTAL IN INR: ${SubTotalAmount.toFixed(2)}`);

  //   if (isGujaratGstNo) {
  //     printRightLine(`IGST @ 18%: ${igstAmount.toFixed(2)}`);
  //   }

  //   printRightLine(`CGST @ 9%: ${cgstAmount.toFixed(2)}`);
  //   printRightLine(`SGST @ 9%: ${sgstAmount.toFixed(2)}`);

  //   footerYRight += totals.spaceBeforeTotal;

  //   // Total highlighted
  //   doc.setFontSize(fonts.sizes.large);
  //   doc.setFont(fonts.primary, "normal");
  //   doc.setTextColor(...colors.gray);
  //   doc.text(
  //     `Total (INR): ${isGujaratGstNo
  //       ? (SubTotalAmount + igstAmount).toFixed(2)
  //       : (SubTotalAmount + cgstAmount + sgstAmount).toFixed(2)
  //     }`,
  //     rightX,
  //     footerYRight
  //   );

  //   // Divider Lines
  //   doc.setDrawColor(...colors.black);
  //   doc.setLineWidth(layout.footer.lineWidth);

  //   doc.line(
  //     rightX,
  //     footerYRight - totals.totalLineOffset,
  //     rightX + totals.totalLineWidth,
  //     footerYRight - totals.totalLineOffset
  //   );
  //   doc.line(
  //     rightX,
  //     footerYRight + 3,
  //     rightX + totals.totalLineWidth,
  //     footerYRight + 3
  //   );

  //   footerYRight += totals.officeStartOffsetY;

  //   // Office addresses
  //   doc.setFontSize(fonts.sizes.small);
  //   doc.setFont(fonts.primary, "normal");
  //   doc.setTextColor(...colors.black);

  //   [
  //     "Reg Office. 86, Shakti Complex, Opp Krishna Hospital,",
  //     "Mota Chiloda, NH-8, 382 355 Gandhinagar - Guj (IND)"
  //   ].forEach(line => {
  //     doc.text(line, rightX, footerYRight);
  //     footerYRight += totals.officeLineHeight;
  //   });

  //   // Yellow Divider
  //   doc.setDrawColor(255, 193, 7);
  //   doc.setLineWidth(0.5);
  //   doc.line(rightX, footerYRight, rightX + 20, footerYRight);

  //   footerYRight += 4;

  //   [
  //     "Corp Office, A-409, The Landmark, Urjanagar 1",
  //     "Kudasan, 382 421 Gandhinagar - Guj (IND)"
  //   ].forEach(line => {
  //     doc.setTextColor(...colors.black);
  //     doc.text(line, rightX, footerYRight);
  //     footerYRight += totals.officeLineHeight;
  //   });
  // };
  const addFooter = (proposalData: any, startY: number) => {
    const { pageWidth, pageHeight, margins, colors, fonts, layout } = constants;
    const { terms, contact, totals } = layout.footer;

    const rightX = layout.sections.rightX;

    // GST Calculations
    const SubTotalAmount = proposalData.mediaInventory.reduce(
      (acc: number, item: any) => acc + (item.amount || 0),
      0
    );
    const igst = SubTotalAmount * 0.18;
    const cgst = SubTotalAmount * 0.09;
    const sgst = SubTotalAmount * 0.09;

    const isGujarat =
      proposalData?.client?.GSTIN?.slice(-2) === GUJARAT_GST_CODE;

    //-------------------------------------------------------
    // 🔍 Estimate Total Block Height (no break allowed)
    //-------------------------------------------------------

    const availableHeight = pageHeight - startY - margins.bottom;

    //-------------------------------------------------------
    // 📌 Ensure TOTALS always print as 1 block
    //-------------------------------------------------------
    console.log("availableHeight", availableHeight)
    // Force page break if footer goes too low
    if (availableHeight < 25) {
      doc.addPage();
      startY = margins.top;
    }

    //-------------------------------------------------------
    // 🧾 Print RIGHT COLUMN — TOTALS (Top aligned always!)
    //-------------------------------------------------------
    let yRight = startY;

    doc.setFontSize(fonts.sizes.normal);
    doc.setFont(fonts.fallback, "bold");
    doc.setTextColor(...colors.black);

    const writeRight = (text: string) => {
      doc.text(text, rightX, yRight);
      yRight += totals.lineHeight;
    };

    writeRight(`SUB TOTAL IN INR: ${SubTotalAmount.toFixed(2)}`);

    if (isGujarat) writeRight(`IGST @ 18%: ${igst.toFixed(2)}`);
    writeRight(`CGST @ 9%: ${cgst.toFixed(2)}`);
    writeRight(`SGST @ 9%: ${sgst.toFixed(2)}`);

    yRight += totals.spaceBeforeTotal;

    // 🎯 Store baseline for Total text
    const totalTextX = rightX;
    const totalTextY = yRight;

    // Total Text
    doc.setFontSize(fonts.sizes.large);
    doc.setFont(fonts.primary, "bold");
    doc.setTextColor(...colors.gray);
    doc.text(
      `Total (INR): ${(SubTotalAmount + (isGujarat ? igst : cgst + sgst)).toFixed(2)}`,
      totalTextX,
      totalTextY
    );

    // 🔽 Top BLACK underline above Total text
    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(0.4);
    doc.line(
      totalTextX,
      totalTextY - totals.totalLineOffset,
      totalTextX + totals.totalLineWidth,
      totalTextY - totals.totalLineOffset
    );

    // 🔽 Bottom GRAY underline exactly under Total text
    doc.setDrawColor(180, 180, 180);
    doc.setLineWidth(0.6);
    doc.line(
      totalTextX,
      totalTextY + 3,
      totalTextX + totals.totalLineWidth,
      totalTextY + 3
    );

    // Reset Y for office details below both lines
    yRight = totalTextY + totals.officeStartOffsetY;
    doc.setTextColor(...colors.black);
    doc.setFont(fonts.primary, "normal");
    doc.setFontSize(fonts.sizes.small);

    // Office Address Section
    [
      "Reg Office. 86, Shakti Complex, Opp Krishna Hospital,",
      "Mota Chiloda, NH-8, 382 355 Gandhinagar - Guj (IND)",
      "",
      "Corp Office, A-409, The Landmark, Urjanagar 1",
      "Kudasan, 382 421 Gandhinagar - Guj (IND)"
    ].forEach(line => {
      if (line === "") {
        doc.setDrawColor(255, 193, 7);
        doc.setLineWidth(0.5);
        doc.line(rightX, yRight, rightX + 20, yRight);
        yRight += 5;
      } else {
        doc.text(line, rightX, yRight);
        yRight += totals.officeLineHeight;
      }
    });


    //-------------------------------------------------------
    // 📜 Print LEFT COLUMN — TERMS
    //-------------------------------------------------------
    let yLeft = startY;

    const ensureNewPage = () => {
      if (yLeft > pageHeight - margins.bottom) {
        doc.addPage();
        yLeft = margins.top;
      }
    };

    doc.setFontSize(fonts.sizes.normal);
    doc.setFont(fonts.fallback, "bold");
    doc.setTextColor(...colors.black);
    doc.text("TERMS & CONDITIONS", margins.left, yLeft);

    yLeft += terms.titleOffsetY;
    doc.setFont(fonts.primary, "normal");
    doc.setFontSize(fonts.sizes.tiny);

    const termDesc = proposalData?.term?.description || "";
    const termLines = termDesc
      .split("\n")
      .map((line: any) => line.trim())
      .filter(Boolean);

    const maxWidth = pageWidth * 0.5 - margins.left;

    termLines.forEach((term: any) => {
      const lines = doc.splitTextToSize(term, maxWidth);
      lines.forEach((textLine: any) => {
        ensureNewPage();
        doc.text(textLine, margins.left, yLeft);
        yLeft += terms.lineHeight;
      });
    });

    //-------------------------------------------------------
    // 📞 Contact Info (below terms)
    //-------------------------------------------------------
    yLeft += terms.spacingBeforeContact;
    ensureNewPage();

    doc.setFontSize(fonts.sizes.normal);
    doc.setFont(fonts.fallback, "bold");
    doc.text("Contact Us", margins.left, yLeft);

    yLeft += contact.lineHeight;
    doc.setFont(fonts.primary, "normal");
    doc.setFontSize(fonts.sizes.small);

    [
      "Call - 95866 22346, 9586522346",
      "E mail - info.craftmedia@gmail.com",
      "Web - www.craftmedia.in"
    ].forEach(line => {
      ensureNewPage();
      doc.text(line, margins.left, yLeft);
      yLeft += contact.lineHeight;
    });
  };

  const printPDF = async () => {
    const { pageWidth, margins, colors, header, border, layout } = constants;
    const proposalData: any = await fetcher(
      "/proposals",
      { id: rowData.id },
      loading
    );

    const headerEndY = addHeader(proposalData);
    const tableStartY = headerEndY + header.spaceAfter;

    doc.setFillColor(...colors.yellow);
    doc.roundedRect(
      margins.left,
      tableStartY - header.height,
      pageWidth - margins.left - margins.right,
      header.height,
      border.radius,
      border.radius,
      "F"
    );

    addTableHeader(tableStartY);

    let isFirstSection = true;
    let finalTableY = y; // Initialize with current Y position after header

    const addSectionTitle = (title: string) => {
      const { fonts, layout } = constants;
      const firstPadding = 5;
      const normalPadding = 8;
      const spacingFactor = 0.5;
      const additionalOffset = 0;
      const sectionIndent = 3;
      doc.setFontSize(fonts.sizes.subtitle);
      doc.setFont(fonts.fallback, "bold");
      y += isFirstSection ? firstPadding : normalPadding;
      doc.text(title, margins.left + sectionIndent, y);
      const textHeight = doc.getTextDimensions(title).h;
      y += textHeight * spacingFactor + additionalOffset;
      isFirstSection = false;
    };

    const renderTable = (section: any) => {
      const columns = section.columns.map((col: any) => ({
        title: col,
        dataKey: normalizeColumnName(col),
      }));

      const rows = section.rows.map((row: any) => {
        let rowData: any = {};
        section.columns.forEach((col: any) => {
          const normalizedCol = normalizeColumnName(col);
          rowData[normalizedCol] = row[normalizedCol] || "N/A";
        });
        return rowData;
      });

      addSectionTitle(section.title);

      doc.autoTable({
        startY: y,
        body: rows,
        columns: columns,
        theme: "striped",
        margin: {
          top: 0,
          bottom: margins.bottom + 3,
          left: margins.left + 3,
          right: margins.right + 3,
        },
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: constants.colors.tableHeaderText,
          fontSize: constants.fonts.sizes.tablehead,
          fontStyle: "bold",
          lineColor: [85, 0, 0, 0],
        },
        bodyStyles: {
          textColor: [...constants.colors.gray],
          fontSize: constants.fonts.sizes.tablehead,
        },
        columnStyles: {
          size: { halign: "center" },
          sqft: { halign: "center" },
          qty: { halign: "center" },
          ratepermonth: { halign: "center" },
          ratepersqft: { halign: "center" },
          amount: { halign: "right" },
        },
        didParseCell: (data: any) => {
          if (data.section === "head") {
            if (["size", "sqft", "qty"].includes(data.column.dataKey)) {
              data.cell.styles.halign = "center";
            }
            if (
              ["ratepermonth", "ratepersqft", "amount"].includes(
                data.column.dataKey
              )
            ) {
              data.cell.styles.halign = "right";
            }
          }
        },
        styles: {
          cellPadding: layout.table.cellPadding,
          overflow: "linebreak",
        },

        didDrawPage: (data: any) => {
          if (data.pageNumber > 1) {
            doc.setFillColor(...colors.yellow);
            doc.roundedRect(
              margins.left,
              margins.top - header.height,
              pageWidth - margins.left - margins.right,
              header.height,
              border.radius,
              border.radius,
              "F"
            );
            doc.setDrawColor(...colors.tableHeaderText);
            doc.setFontSize(constants.fonts.sizes.small);
            doc.setFont(constants.fonts.fallback, "bold");
            doc.setTextColor(...constants.colors.black);
            doc.text(
              section.title,
              layout.table.newPageTitleX,
              layout.table.newPageTitleY
            );

            // No footer border on continuation pages since they only contain table content
          }
        },
        didDrawCell: (data: any) => {
          if (data.section === "head") {
            const { x, y: cellY, width, height } = data.cell;
            doc.setDrawColor(55, 55, 55);
            doc.setLineWidth(layout.footer.lineWidth);
            doc.line(x, cellY, x + width, cellY); // Top border
            doc.line(x, cellY + height, x + width, cellY + height); // Bottom border
          }
        },
      });

      y = doc.lastAutoTable.finalY;
      finalTableY = y; // Update the final Y position after each table
    };

    const headerColumns = [
      {
        title: "SALE OF SPACE FOR OUTDOOR ADVERTISEMENT HO WEIGHTING",
        columns: [
          "MEDIA ID",
          "CITY",
          "LOCATION",
          "SIZE",
          "SQ FT",
          "QTY",
          "RATE PER MONTH",
          "ST DATE",
          "END DATE",
          "AMOUNT",
        ],
        rows:
          proposalData.mediaInventory.filter(
            (item: any) => item.groupCode === "SOAH"
          ).length > 0
            ? generateRows(
              proposalData.mediaInventory.filter(
                (item: any) => item.groupCode === "SOAH"
              ),
              "mediaItemId"
            )
            : null,
      },
      {
        title: "PURCHASE OF SPACE FOR OUTDOOR ADVERTISEMENT HOARDING",
        columns: [
          "AGENCY ID",
          "CITY",
          "LOCATION",
          "SIZE",
          "SQ FT",
          "QTY",
          "RATE PER MONTH",
          "ST DATE",
          "END DATE",
          "AMOUNT",
        ],
        rows:
          proposalData.mediaInventory.filter(
            (item: any) => item.groupCode === "POAH"
          ).length > 0
            ? generateRows(
              proposalData.mediaInventory.filter(
                (item: any) => item.groupCode === "POAH"
              ),
              "agencyId"
            )
            : null,
      },
      {
        title: "FLEX BANNER PRINTING HOARDING",
        columns: [
          "MEDIA ID",
          "CITY",
          "LOCATION",
          "SIZE",
          "SQ FT",
          "QTY",
          "RATE PER SQ FT",
          "MATERIAL",
          "AMOUNT",
        ],
        rows:
          proposalData.mediaInventory.filter(
            (item: any) => item.groupCode === "FBPH"
          ).length > 0
            ? generateRows(
              proposalData.mediaInventory.filter(
                (item: any) => item.groupCode === "FBPH"
              ),
              "agencyId"
            )
            : null,
      },
      {
        title: "FLEX BANNER MOUNTING",
        columns: [
          "MEDIA ID",
          "CITY",
          "LOCATION",
          "SIZE",
          "SQ FT",
          "QTY",
          "RATE PER SQ FT",
          "AMOUNT",
        ],
        rows:
          proposalData.mediaInventory.filter(
            (item: any) => item.groupCode === "FBM"
          ).length > 0
            ? generateRows(
              proposalData.mediaInventory.filter(
                (item: any) => item.groupCode === "FBM"
              ),
              "agencyId"
            )
            : null,
      },
      {
        title: "SALE OF SPACE FOR OUTDOOR ADVERTISEMENT POLE KIOSK",
        columns: [
          "ROUTE ID",
          "CITY",
          "LOCATION",
          "SIZE",
          "SQ FT",
          "QTY",
          "RATE PER MONTH",
          "ST DATE",
          "END DATE",
          "AMOUNT",
        ],
        rows:
          proposalData.mediaInventory.filter(
            (item: any) => item.groupCode === "SOAPK"
          ).length > 0
            ? generateRows(
              proposalData.mediaInventory.filter(
                (item: any) => item.groupCode === "SOAPK"
              ),
              "routeId"
            )
            : null,
      },
      {
        title: "FLEX BANNER PRINTING AND MOUNTING POLE KIOSK",
        columns: [
          "MEDIA ID",
          "ZONE",
          "MEDIA TYPE",
          "SIZE",
          "SERIES",
          "QTY",
          "RATE PER POLE KIOSK",
          "MATERIAL",
          "AMOUNT",
        ],
        rows:
          proposalData.mediaInventory.filter(
            (item: any) => item.groupCode === "FPMPK"
          ).length > 0
            ? generateRows(
              proposalData.mediaInventory.filter(
                (item: any) => item.groupCode === "FPMPK"
              ),
              "mediaItemId"
            )
            : null,
      },
    ].filter((section) => section.rows !== null);

    headerColumns.forEach((section) => {
      renderTable(section);
    });

    // Draw main border around all table sections - only if we have valid dimensions
    const totalTableHeight = finalTableY - (tableStartY - header.height);

    // Only draw border if we have valid positive dimensions
    if (totalTableHeight > 0 && finalTableY > tableStartY) {
      doc.setDrawColor(180, 180, 180); // light gray
      doc.setLineWidth(layout.footer.lineWidth);

      doc.roundedRect(
        margins.left,
        tableStartY - header.height,
        pageWidth - margins.left - margins.right,
        totalTableHeight,
        border.radius,
        border.radius,
        "S"
      );
    }

    const footerStartY = finalTableY + 7;
    addFooter(proposalData, footerStartY);
    doc.save(`${rowData.prososalNo}.pdf`);
  };

  return (
    <div>
      <Button
        color="link"
        className="p-0 text-danger"
        onClick={printPDF}
        id="downloadTooltip"
      >
        {downloadPDF.icon}
      </Button>
      <UncontrolledTooltip
        isOpen={tooltipOpen}
        target="downloadTooltip"
        toggle={toggleTooltip}
      >
        DownloadPDF
      </UncontrolledTooltip>
    </div>
  );
}
